import DialogConfirm from './components/dialogs/DialogConfirm.vue';
import DialogForm from './components/dialogs/DialogForm.vue';
import DialogPortal from './components/dialogs/DialogPortal.vue';

export const TYPES = {
  confirm: 1,
  form: 2,
  portal: 3,
};

export const TYPES_DATA = {
  [TYPES.confirm]: {
    component: DialogConfirm,
  },
  [TYPES.form]: {
    component: DialogForm,
  },
  [TYPES.portal]: {
    component: DialogPortal,
  },
  // Add custom type
};

const generateUid = () => crypto.randomUUID();

export class Dialog {
  constructor(options) {
    this.id = generateUid();
    this.state = true;
    this.type = options.type;
    this.attrs = { id: this.id, ...(options.attrs || {}) };
    this.listeners = options.listeners || {};
  }

  get component() {
    const { type } = this;
    return TYPES_DATA[type].component;
  }
}
